CheckoutV2.Shipping = function( checkout ) {
    var shipping = this;
    var shouldOpenSelectModal = false;
    var shouldOpenEditModal = false;
    var addressFormPrefix;

    shipping.field_errors = {
        country: 'Required',
        taxCode: 'Required',
        name_first: 'Requires 1-30 character(s)',
        name_last: 'Requires 1-30 character(s)',
        address: 'Requires 1-120 character(s)',
        city: 'Requires 1-30 character(s)',
        state: 'Required',
        zip: 'Invalid format',
        phone: 'Invalid format',
        email: 'Required'
    };

    shipping.requestedQuoteType = 'auto';

    shipping.saved = true;

    shipping.$wrap = $('.js-shipping-options-widget');
    shipping.$cShopping = $('.cshopping', shipping.$wrap);
    shipping.$showEmailCart = $('#showEmailCart', shipping.$wrap);

    shipping.$anchor = $('a[name=shipping]');
    shipping.$proceed = $('#shipping-proceed');
    shipping.$displayTypeSelect = $('.js-shipping-display-type');

    shipping.$serviceGroupsWrap = $('.shipping-service-groups-wrap');
    shipping.$servicesContent = $('#shipping-services-content-main');
    shipping.$servicesContentAlt = $('#shipping-services-content-alt');
    shipping.$servicesContentAltWrap = $('.pickcarrierAlt');
    shipping.$servicesContentAll = $('.shipping-services-content');
    shipping.$serviceServicesWrap = $('.shipping-service-couriers-wrap');
    shipping.$couriers = $('#shipping-couriers');
    shipping.$couriersContent = $('#shipping-couriers-content');
    shipping.$serviceTpl = $('#shipping-service-tpl');
    shipping.$courierServicesTpl = $('#shipping-courier-services-tpl');
    shipping.$serviceDesc = $('#shipping-service-desc');
    shipping.$disclaimers = $('#shipping-map');

    shipping.$overrideWrap = $('#shipping-override-wrap');
    shipping.$override = $('.js-shipping-override');
    shipping.$overrideAmt = $('.js-shipping-override-amount');
    
    shipping.$shippingGroups = $('.js-change-shipping-group');
    shipping.$shippingServices = $('.js-change-shipping-service');
    shipping.$shippingCouriers = $('.js-change-shipping-courier');

    shipping.$groupDetailsContainer = $('#shipping-group-details-container');

    shipping.$chooseShippingMethod = $('.js-choose-shipping-method');
    shipping.$changeShippingModal = $('.js-change-shipping-modal');

    shipping.$changeAddressLink = $('.js-change-address-link');

    shipping.$selectAddressModal = $('#selectAddressModal');
    shipping.$addEditAddressModal = $('#addEditAddressModal');
    shipping.$addressFormModalTitle = $('.js-modal-title', shipping.$addEditAddressModal);
    shipping.$addEditAddressCountry = $('.js-shipping_country', shipping.$addEditAddressModal);
    shipping.$addEditAddressState = $('.js-shipping_state', shipping.$addEditAddressModal);
    shipping.$addCompanyLink = $('.js-add-company-link', shipping.$addEditAddressModal);
    shipping.$addCompanyName = $('.js-company-name-wrapper', shipping.$addEditAddressModal);
    shipping.$addEditShipAltPhoneShowLink = $('.js-add-alt-phone-link', shipping.$addEditAddressModal);
    shipping.$addEditAddressAltPhone = $('.js-alt-phone-wrapper', shipping.$addEditAddressModal);
    
    shipping.$optionsContainer = $('.js-shipping-options');
    shipping.$addressFormCountry = $('#addressForm_country');
    shipping.$addressFormState = $('#addressForm_state');
    shipping.$pickupModal = $('.js-pickup-modal');

    shipping.shippingETD = false
    shipping.shippingMethod = '';
    shipping.shippingResponse = {};
    shipping.inStorePickup = 0;
    shipping.originalInStorePickup = 0;
    shipping.originalInternationalShipping = 0;

    // Used in validation, assigned in checkoutV2.setPayment    
    shipping.$shippingOptionsError = false;
    shipping.$shippingOptionsErrorMsg = false;
    shipping.$shippingOptionsErrorClose = false;
        
    shipping.init = function() {
        shipping.listen();
    };

    shipping.listen = function() {
        shipping.$proceed.on('click', shipping.proceed);

        shipping.$wrap.on('change', '.js-shipping-display-type', shipping.changeDisplayType);

        shipping.$wrap.on('change', '.js-shipping-override', shipping.changeOverride);

        shipping.$wrap.on('input propertychange', '.js-shipping-override-amount', shipping.changeOverride);

        shipping.$wrap.on('change', '.js-change-shipping-group', function() {
            var $this = $(this);
            var gid = $this.data('shipping-service-group-id');
            var method = $this.data('shipping-method');
            var etd = $this.data('shipping-etd');
            var review = $this.data('review') || false;
            shipping.inStorePickup = $this.data('instorepickup') || 0;
            if (!review) shipping.changeServiceGroup( gid, method, etd );
            shipping.$chooseShippingMethod
                .data('shipping-type', 'groups')
                .data('shipping-etd', etd) 
                .data('shipping-method', method)
                .data('shipping-service-group-id', gid);

            $this.parent().parent().parent().siblings('.shipping-group-details').removeClass('d-block').addClass('d-none');
            $this.parent().parent().parent().siblings('.shipping-group-details.group-'+gid+'-details').removeClass('d-none').addClass('d-block');
            if (!review) {
                checkout.shipping.buildContent( checkout.shipping.shippingResponse, 'review' )
            }
        });

        shipping.$wrap.on('click', '.js-shipping-row', function(e) {
            var $radioBtn = $(e.currentTarget).find('input[type="radio"]');
            if (!$radioBtn.is(':checked')) $radioBtn.prop('checked', true).trigger('change');
        });

        shipping.$wrap.on('change', '.js-change-shipping-service', function() {
            var $this = $(this);
            var shippingServiceCode = $this.data('shipping-service-code');
            var method = $this.data('shipping-method');
            var review = $this.data('review') || false;
            if (shippingServiceCode) {
                if (!review)
                    shipping.changeService( shippingServiceCode, method );

                shipping.$chooseShippingMethod
                    .data('shipping-type', 'couriers')
                    .data('shipping-method', method)
                    .data('shipping-service-code', shippingServiceCode);

                $this.parent().parent().parent().find('.shipping-estimate-msg').removeClass('d-block').addClass('d-none');
                $this.parent().parent().parent()
                    .find('.js-shipping-row.js-shipping-service-details')
                    .removeClass('d-block').hide();
                $this.parent().parent()
                    .siblings( '.js-shipping-service-details.' + shippingServiceCode + '-details' )
                    .removeClass('d-none').addClass('d-block');
                $this.parent().siblings('.shipping-estimate-msg').removeClass('d-none').addClass('d-block');
                if (!review) {
                    checkout.shipping.buildContent( checkout.shipping.shippingResponse, 'review' );
                } else 
                    checkout.shipping.$changeShippingModal.modal('handleUpdate');
            }
            
        });

        shipping.$wrap.on('click', '.js-change-shipping-courier', function() {
            var $this = $(this);
            var selector = $this.attr('href') + ' input:checked';
            var review = $this.data('review') || false;
            if ($(selector).length > 0)  {
                var shippingServiceCode = $(selector).data('shipping-service-code');
                var method = $(selector).data('shipping-method');
                if (shippingServiceCode) {
                    if (!review)
                        shipping.changeService( shippingServiceCode, method );


                        shipping.$chooseShippingMethod
                            .data('shipping-type', 'couriers')
                            .data('shipping-method', method)
                            .data('shipping-service-code', shippingServiceCode);

                    $(selector).parent().siblings('.shipping-estimate-msg').removeClass('d-none').addClass('d-block');
                    $(selector).parent().parent().siblings( '.' + shippingServiceCode + '-details' ).removeClass('d-none').addClass('d-block');
                    $(selector).parent().siblings('.js-shipping-service-details.' +shippingServiceCode + '-details' )
                        .removeClass('d-none').addClass('d-block');
                    if (!review) {
                        checkout.shipping.buildContent( checkout.shipping.shippingResponse, 'review' )
                    } else
                        checkout.shipping.$changeShippingModal.modal('handleUpdate');
                }
            }
        });

        shipping.$chooseShippingMethod.on('click', function() {
            var $this = $(this);
            var type = $this.data('shipping-type');
            if (type) {
                var method = $this.data('shipping-method');
                if (type == 'groups') {
                    var etd = $this.data('shipping-etd');
                    var gid = $this.data('shipping-service-group-id');
                    shipping.changeServiceGroup( gid, method, etd );
                } else {
                    shippingServiceCode = $this.data('shipping-service-code');
                    shipping.changeService( shippingServiceCode, method );
                };
                checkout.shipping.buildContent( checkout.shipping.shippingResponse );
                checkout.shipping.$changeShippingModal.modal('hide');
            }
        });

        shipping.$changeShippingModal.on('hidden.bs.modal', function() {
            checkout.shipping.buildContent( checkout.shipping.shippingResponse, "review" );
        } );

        // GUEST, on country change, reload states
        shipping.$addressFormCountry.on('change', function() {
            shipping.getStates(shipping.$addressFormCountry,shipping.$addressFormState);
            shipping.setFieldVisibility(shipping.$addEditAddressModal);
        });
        
        shipping.$addCompanyLink.on('click', function() {
                shipping.$addCompanyLink.toggle();
                shipping.$addCompanyName.removeClass('collapse');
        });

        shipping.$addEditShipAltPhoneShowLink.on('click', function() {
                shipping.$addEditShipAltPhoneShowLink.toggle();
                shipping.$addEditAddressAltPhone.removeClass('collapse');
        });

        shipping.$optionsContainer.on('click', '.js-change-address-link', function(e) {
            e.preventDefault();
            if ( checkout.session.isLoggedIn() ) {
                shipping.$selectAddressModal.modal('show');
            } else {
                if ($(this).data('shipid')) { // not sure what this does ???
                    shipping.prefillAddEditAddressForm($(this).data('shipid'));
                } else { // moved guest logic from below (shipping.$changeAddressLink) to here
                    addressFormPrefix = '';
                    shipping.prefillAddEditAddressForm();
                }
                shipping.$addEditAddressModal.modal('show');
            }
        });

        shipping.$pickupModal.on('click', '.js-confirm-pickup', function() {
            shipping.$pickupModal.modal('hide');
            checkout.nextStep();
        });

        // Changing address as guest
        shipping.$changeAddressLink.on('click', function() { // this is not being called, above is, trying to listen to the same thing
            addressFormPrefix = '';
            shipping.prefillAddEditAddressForm();
            shipping.getStates(shipping.$addEditAddressCountry, shipping.$addEditAddressState, checkout.session.shipping.state);
            shipping.$addEditAddressModal.modal('show');
            shipping.setFieldVisibility(shipping.$addEditAddressModal);
        });

        // bind all events to the modal cuz it's rendered on page load, then filter by element
        shipping.$selectAddressModal
            .on('hidden.bs.modal', function() {
                if ( shouldOpenEditModal ) {
                    shouldOpenEditModal = false;
                    shouldOpenSelectModal = true;
                    shipping.$addEditAddressModal.modal('show');
                }
            })
            .on('click', '.js-choose-address', function() {
                var shipID = $('.js-selected-address:checked').parent().data('shipid');
                shipping.useThisAddress( shipID );
            })
            .on('click', '.js-add-address-link', function() {
                addressFormPrefix = 'Add ';
                shipping.prefillAddEditAddressForm();
                shipping.getStates(shipping.$addEditAddressCountry,shipping.$addEditAddressState);
                shouldOpenEditModal = true;
                shipping.$selectAddressModal.modal('hide');
            })
            .on('click', '.js-edit-address-link', function() {
                var $this = $(this);
                addressFormPrefix = 'Edit ';
                shouldOpenEditModal = true;
                shipping.prefillAddEditAddressForm($this.data('shipid'));
                shipping.getStates(shipping.$addEditAddressCountry,shipping.$addEditAddressState, $this.data('state'));
                shipping.$selectAddressModal.modal('hide');
            });

        shipping.$addEditAddressModal
            .on('hidden.bs.modal', function() {
                $(this).find('input, select').each(function( index, item ) {
                    shipping.removeFieldError( $( item ) );
                });
                
                if ( shouldOpenSelectModal ) {
                    shouldOpenSelectModal = false;
                    shipping.$selectAddressModal.modal('show');
                }
            })
            .on('shown.bs.modal', function() {
                var $this = $(this);
                if ($this.find('#addEditAddressForm_country').length
                    && !$this.find('#addEditAddressForm_country').val()
                    ) {
                    shipping.fieldError( $this.find('#addEditAddressForm_country'), shipping.field_errors.country );
                }

                if ($this.find('#addEditAddressForm_state').length
                    && !$this.find('#addEditAddressForm_state').val()
                    ) {
                    shipping.fieldError( $this.find('#addEditAddressForm_state'), shipping.field_errors.state );
                }
            })
            .on('blur input', 'input, select', function() {
                if( this.checkValidity() ) {
                    shipping.fieldError( $( this ), false );
                }
                else {
                    shipping.fieldError( $(this), shipping.getFieldError( this.name ) );
                }
            })
            .on('change', '#addEditAddressForm_country', function() {
                var $countryField = $('#addEditAddressForm_country', shipping.$addEditAddressModal);
                var $stateField = $('#addEditAddressForm_state', shipping.$addEditAddressModal);
                shipping.getStates($countryField, $stateField);
                if ( !$countryField.val() ) {
                    shipping.fieldError( $countryField, shipping.field_errors.country );
                } else {
                    shipping.fieldError( $countryField, false );
                    $.get('/includes/subCountry.cgi?ship=ship&country=' + $countryField.val(), function( data ) {
                        var lines = data.split("\n");
                        if (lines.length <= 1)  {
                            $stateField.html('');
                            $stateField.removeAttr('required');
                            $stateField.hide();
                            shipping.removeFieldError( $stateField );
                            return;
                        } else {
                            $stateField.show();
                            $stateField.prop('required', true);
                        }
                        var state_array = [];
                        for (var i = 0; lines.length > i; i++) {
                            var opts = lines[i].split("|");
                            if (opts.length < 2) 
                                continue;
                            state_array.push({ 
                                shipping_state: opts[0],
                                subcountry_name: opts[1]
                            });
                        }
                        if (!$stateField.val()) {
                            shipping.fieldError( $stateField, shipping.field_errors.state );
                        }
                    });
                }
                shipping.setFieldVisibility(shipping.$addEditAddressModal);
            })
            .on('blur', '#addEditAddressForm_state', function() {
                var $this = $(this);
                if ($this.val()) {
                    shipping.fieldError( $this, false );
                } else {
                    shipping.fieldError( $this, shipping.field_errors.state );
                }
            })
            .on('click', '.js-save-address-btn', function() {
                var $this = $(this);
                $this.prop('disabled', true);
                shipping.saveAddress( function() { $this.prop( "disabled", false ) } );
            });
        
        // listen for cart content changes
        checkout.cart.$wrap.on('loading', function( loadingMsg ) {
            shipping.loading(loadingMsg);
        });

        checkout.cart.$wrap.on('loadDone', function( stepChanged ) {
            shipping.loading(false);

            if (
                checkout.currentStepName() != 'cart'
                && stepChanged == 'cart'
            )
                shipping.buildContent();

        });

        checkout.cart.$wrap.on('loadFail', function() {
            shipping.loading(false);
            shipping.$wrap.hide();
        });

        shipping.$wrap.on('click', '#shipping-options-error .close', function() {
            shipping.$shippingOptionsErrorMsg.html('');
            shipping.$shippingOptionsError.hide();
        });
    };

    shipping.fieldError = function( $field, errMsg ) {
        var $feedback = shipping.getFeedback( $field );
        if ( errMsg ) {
            $feedback.removeClass( "text-success" )
                     .addClass( "text-danger" )
                     .html( errMsg );
        }
        else {
            $feedback.removeClass( "text-danger" )
                     .addClass( "text-success" )
                     .html( "<i class='fa fa-check'></i>" );
        }
    };

    shipping.removeFieldError = function( $field ) {
        var $feedback = shipping.getFeedback( $field );
        $feedback.html( "" );
    };

    shipping.getFieldError = function( fieldName ) {
        if( shipping.field_errors[ fieldName ] ) return shipping.field_errors[ fieldName ];
        // remove everything before the first underscore
        var shortName = fieldName.replace( /(.*?)_/, "" );
        return shipping.field_errors[ shortName ];
    };

    shipping.getFeedback = function( $field ) {
        var feedbackClass = $field.data( 'feedback' );
        return $field.closest( ".modal" ).find( '.' + feedbackClass );
    };
    
    shipping.useThisAddress = function( shipID ) {
        var data = {
            shipping: {}
        };

        if ( shipID ) {
            data.shipID = shipID;
            data.shipping.country = $('#js-address-list-country-' + shipID).text();
            data.shipping.taxCode = $('#js-address-list-taxCode-' + shipID).text();
            data.shipping.company = $('#js-address-list-company-' + shipID).text();
            data.shipping.firstname = $('#js-address-list-firstname-' + shipID).text();
            data.shipping.lastname = $('#js-address-list-lastname-' + shipID).text();
            data.shipping.address1 = $('#js-address-list-address-1-' + shipID).text();
            data.shipping.address2 = $('#js-address-list-address-2-' + shipID).text();
            data.shipping.city = $('#js-address-list-city-' + shipID).text();
            data.shipping.state = $('#js-address-list-state-' + shipID).text();
            data.shipping.zip = $('#js-address-list-zip-' + shipID).text();
            data.shipping.phone = $('#js-address-list-phone-' + shipID).text();
            data.shipping.phone_alternate = $('#js-address-list-phone-alternate-' + shipID).text();
            data.shippingOverride = 0;

            // sync data
            data.shipping.shipping_country = data.shipping.country;
            data.shipping.shipping_taxCode = data.shipping.taxCode;
            data.shipping.shipping_company = data.shipping.company;
            data.shipping.shipping_name_first = data.shipping.firstname;
            data.shipping.shipping_name_last = data.shipping.lastname;
            data.shipping.shipping_address = data.shipping.address1;
            data.shipping.shipping_address2 = data.shipping.address2;
            data.shipping.shipping_city = data.shipping.city;
            data.shipping.shipping_state = data.shipping.state;
            data.shipping.shipping_zip = data.shipping.zip;
            data.shipping.shipping_phone = data.shipping.phone;
            data.shipping.shipping_phone_alternate = data.shipping.phone_alternate;

            data.shipping_city_original = data.shipping.city;
            data.shipping_country_original = data.shipping.country;
            data.shipping_state_original = data.shipping.state;
            data.shipping_zip_original = data.shipping.zip;
        } else {
            data = checkout.shipinfo.getFormData();
        }

        checkout.cart.shipping.$country.val(data.shipping.country);
        checkout.cart.shipping.$zip.val(data.shipping.zip);
        checkout.cart.shipping.zip = data.shipping.zip;

        checkout.session.set(data);
        checkout.session.save();

        if (shipID) { // need to update form data
            checkout.shipinfo.setFormDataFromSession();
        }

        if (checkout.shipinfo) {
            checkout.shipinfo.displayShippingAddress(null, !!( data.shipping.country != 'US') );
        }

        checkout.cart.shipping.calc(true, true);
           checkout.cart.shipping.updateEstimatedShippingLink();

        shipping.$selectAddressModal.modal('hide');

        checkout.shipinfo.setFieldVisibility(shipping.$addEditAddressModal);
    }

    //
    // this function loads up the select address modal with the data receive back from 
    // saving to db.
    //
    shipping.loadAddresses = function( data ) {
        var addresses = [];
        $.each(data, function( i, contactInfo ) {
            addresses[i] = contactInfo;
        });
        
        var newList = {
            currentShipID: checkout.session.get('shipID'),
            addresses: addresses,
        }

        $('.js-address-list', shipping.$selectAddressModal).html(
            Jemplate.process('shippingAddressRows', newList)
        );
    }

    shipping.prefillAddEditAddressForm = function( shipID ) {
        var isLoggedIn = checkout.session.isLoggedIn();
        if ( addressFormPrefix ) shipping.$addressFormModalTitle.html(addressFormPrefix + 'Shipping Address');
        // need to preload Form
        if ( isLoggedIn ) {
            if ( shipID ) {
                shipping.setFormData ({
                    country: $('#js-address-list-country-' + shipID).text(),
                    taxCode: $('#js-address-list-taxCode-' + shipID).text(),
                    company: $('#js-address-list-company-' + shipID).text(),   
                    firstname: $('#js-address-list-firstname-' + shipID).text(),
                    lastname: $('#js-address-list-lastname-' + shipID).text(),
                    address1: $('#js-address-list-address-1-' + shipID).text(),
                    address2: $('#js-address-list-address-2-' + shipID).text(),
                    city: $('#js-address-list-city-' + shipID).text(),
                    state: $('#js-address-list-state-' + shipID).text(),
                    zip: $('#js-address-list-zip-' + shipID).text(),
                    phone: $('#js-address-list-phone-' + shipID).text(),
                    phone_alernate: $('#js-address-list-phone-alternate-' + shipID).text(),
                    shipID: shipID,
                });
            } else {
                $('input', shipping.$addEditAddressModal).not('#addEditAddressForm_email').val('');
            }
        } else {
            // load with guest data
            var $options = $('#addressForm_state > option').clone();
            $('#addEditAddressForm_state').empty();
            $('#addEditAddressForm_state').append($options);
            $('#addEditAddressForm_state').val(checkout.shipinfo.fields.state.val());
            // ensure that a hidden state input on addressForm is also hidden on addEditAddressForm
            $('#addEditAddressForm_state').prop( 'required', $('#addressForm_state').prop('required') );
            $('#addEditAddressForm_state').parent().css( 'display', $('#addressForm_state').parent().css('display') );
            shipping.setFormData ({
                country: checkout.shipinfo.fields.country.val(),
                taxCode: checkout.shipinfo.fields.taxCode.val(),
                company: checkout.shipinfo.fields.company.val(),
                firstname: checkout.shipinfo.fields.firstname.val(),
                lastname: checkout.shipinfo.fields.lastname.val(),
                address1: checkout.shipinfo.fields.address1.val(),
                address2: checkout.shipinfo.fields.address2.val(),
                city: checkout.shipinfo.fields.city.val(),
                state: checkout.shipinfo.fields.state.val(),
                zip: checkout.shipinfo.fields.zip.val(),
                phone: checkout.shipinfo.fields.phone.val(),
                phone_alternate: checkout.shipinfo.fields.phone_alternate.val(),
                email: checkout.shipinfo.fields.email.val(),
            });
        }
        shipping.setFieldVisibility(shipping.$addEditAddressModal);
    };    

    shipping.setFormData = function( data ) {
        $('.js-shipping_country').val(data.country);
        $('.js-shipping_taxCode').val(data.taxCode);
        $('.js-shipping_company').val(data.company);
        $('.js-shipping_firstname').val(data.firstname);
        $('.js-shipping_lastname').val(data.lastname);
        $('.js-shipping_address1').val(data.address1);
        $('.js-shipping_address2').val(data.address2);
        $('.js-shipping_city').val(data.city);
        $('.js-shipping_state').val(data.state);
        $('.js-shipping_zip').val(data.zip);
        $('.js-shipping_phone').val(data.phone);
        $('.js-shipping_phone_alternate').val(data.phone_alternate);
        $('.js-shipping_shipID').val(data.shipID);
        $('.js-shipping_email').val(data.email);
    };

    shipping.getFormData = function() {
        var isLoggedIn = checkout.session.isLoggedIn();
        var data = {};
        $('[ID^=addEditAddressForm_]:input').each(function( idx, elem ) {
            if ( isLoggedIn ) {
                var newKeyArr = elem.name.split('shipping_');
                if ( newKeyArr.length > 1 ) {
                    data[ 'ship_' + newKeyArr[1] ] = ($(elem).val()) ? String($(elem).val()) : '';
                    data[ 'shipping_' + newKeyArr[1] ] = ($(elem).val()) ? String($(elem).val()) : '';
                }
            } else {
                data[ elem.name ] = ($(elem).val()) ? String($(elem).val()) : '';
            }
        });

        return data;
    };

    shipping.saveAddress = function( cb ) {
        var guestFormValid = true;
        var data = shipping.getFormData();
        $('[ID^=addEditAddressForm_]:input').each(function( idx, elem ) {
            if( elem.checkValidity() ) {
                shipping.fieldError( $(elem), false );
            }
            else {
                shipping.fieldError( $(elem), shipping.getFieldError( elem.name ) );
                guestFormValid = false;
            }
        } );

        // set keys to make displayShippingAddress() happy
        data.company = data.shipping_company;
        data.firstname = data.shipping_name_first;
        data.lastname = data.shipping_name_last;
        data.address1 = data.shipping_address;
        data.address2 = data.shipping_address2;
        data.city = data.shipping_city;
        data.state = data.shipping_state;
        data.country = data.shipping_country;
        data.taxCode = data.shipping_taxCode;
        data.zip = data.shipping_zip;
        data.phone = data.shipping_phone;
        data.phone_alternate = data.shipping_phone_alternate;
        data.email = data.shipping_email;
        data.address_save = data.shipping_address_save;

        var isLoggedIn = checkout.session.isLoggedIn();
        if ( isLoggedIn ) {
            delete data.ship_email;
            delete data.email;
            delete data.shipping_email;

            var params = {
                url: '/MyAccount/Shipping/',
                method: 'POST',
                dataType: 'json',
                data: data
            };
            var action = 'add';
            var shipID = '';

            if ( $('#addEditAddressForm_shipID').val() ) {
                action = 'update';
                params.data.shipID = $('#addEditAddressForm_shipID').val();
                params.url += params.data.shipID + '/';
                params.method = 'PUT';
            }

            var message = 'Unable to ' + action + ' Shipping Address';

            $.ajax(params).done( function( data ) {
                shipping.$addEditAddressModal.modal('hide');
                shipping.loadAddresses( data );
                cb();
            }).fail( function( xhr ) {
                var error_json = xhr.responseJSON;

                shipping.$addEditAddressModal.find( "input, select" ).each( function( i, input ) {
                    shipping.fieldError( $( input ), false );
                } );

                if( error_json && error_json.validation_errors ) {
                    Object.keys( error_json.validation_errors ).forEach( function( key ) {
                        var targetSelector = ".js-" + key.replace( "ship_", "shipping_" );
                        var $target = shipping.$addEditAddressModal.find( targetSelector );
                        if( $target.length ) {
                            shipping.fieldError( $target, error_json.validation_errors[ key ] );
                        }
                    });
                }
                cb();
            });
        } else {
            if (!guestFormValid) {
                cb();
                return;
            } else {
                checkout.session.set({
                    email: data.email,
                    shipping: data
                });
                checkout.session.save();
				var usePoETA = !!( data.country != 'US');
                checkout.shipinfo.setFormDataFromSession();
                checkout.shipinfo.displayShippingAddress(null, usePoETA);

                // update / recalculate shipping 
                checkout.cart.shipping.$country.val(checkout.shipinfo.fields.country.val());
                checkout.cart.shipping.$zip.val(checkout.shipinfo.fields.zip.val());
                checkout.cart.shipping.zip = checkout.shipinfo.fields.zip.val();
                checkout.cart.shipping.calc(true, true, function() {
                	checkout.shipinfo.displayShippingAddress(null, usePoETA);
                	checkout.cart.shipping.updateEstimatedShippingLink();
				});
                cb();
                shipping.$addEditAddressModal.modal('hide');
            }
        }
    };

    this.setFieldVisibility = function( $form ) {
        if ( ! $form ) $form = $( ".js-shipping" );

        var address = shipping.getFormData();
        var result = window.addressValidator.getFieldDisplay( address );
        $.each( result, function( field, visibility ) {
            // var $field = shipinfo.fields[ field ];
            var selector = ".js-address-form *[name=" + field + "]";
            var $field = $( selector );
            if ( ! $field.length ) return;
            var $container = $field.closest( ".input-row" );
            $container.toggle( visibility );
        } );

        var isLoggedIn = checkout.session.isLoggedIn();
        if ( isLoggedIn ) $('#emailRows').hide();
    };

    shipping.getStates = function( countrySelect, stateSelect, currentState ) {
        country = countrySelect.val();

        if (shipping.stateRequest) shipping.stateRequest.abort();

        stateSelect.prop('disabled', true);
        shipping.stateRequest = checkout.remote.call({
            cache: true,
            data: {
                step: 'billship',
                action: 'getStates',
                country: country,
            }
        })
            .done(function( response ) {
                shipping.buildStates(response.data,stateSelect,currentState);
                stateSelect.show().parent().show();
            })
            .fail(function( request ) {

            })
            .always( function() {
                shipping.stateRequest = false;
            } );
    };

    shipping.buildStates = function( states,stateSelect,currentState ) {
        selectState = currentState || '';
        var noState = (selectState && states.length > 1) ? '' : ' selected ';
        var options = [
                '<option ' + noState + ' value="">* Select State/Province/Territory</option>'
            ];

        if (states.length < 1) {
            stateSelect.html(options);
            stateSelect.parent().hide();
            return;
        }

        $.each(states, function( i, states ) {
            var optionString = '<option value="' + states.state + '" ';
            if (states.state == selectState) {
                optionString += 'selected';
            }
            optionString += '>' + states.name + '</option>';
            options.push( optionString );
        });

        stateSelect.html(options);
        stateSelect.removeAttr('disabled');
        $('.stateLabel').show();
        if (selectState) {
            stateSelect.val(selectState);
        }
    };

    shipping.buildContent = function( res, section ) {
        var courierRates = [];
        var couriersHideOthersWhenAvail = {};
        var courierTabs = [];
        var couriersContent = [];
        var invalidCourierRates = {};
        var shipmentCouriers = {};
        var shipmentServices = {};
        checkout.shipping.shippingResponse = res;
        
        var selectedService = checkout.shippingServices[ checkout.shippingServiceCode ];
        var groupRatesSorted = [];
        var serviceOptions = [];
        if (res.serviceGroupRates) {
            Object.keys( res.serviceGroupRates ).forEach( function( e ) {
                var elem = res.serviceGroupRates[e];
                if (elem.details) {
                    elem.detailText = shipping.showRatesDetails( elem );
                    res.serviceGroupRates[e].detailText = shipping.showRatesDetails( elem );
                }
                if (elem.shippingServiceGroupID == checkout.shippingServiceGroupID) {
                    checkout.shipping.setShippingMethod(elem.cartName);
                    var etd;
                    if (elem.deliveryETA['2']) {
                        etd = checkout.globals.getDateRangeLong( elem.deliveryETA['1'], elem.deliveryETA['2'] );
                    } else if (elem.deliveryETA['1']) { 
                        etd = checkout.globals.getDateRangeLong( elem.deliveryETA['1'] );
                    } else {
                        if (elem.inStorePickup && elem.daysInTransit) {
                            etd = elem.daysInTransit;
                        } else {
                            etd = 'Unknown';
                        }
                    }
					if (elem.inStorePickup)
                        checkout.shipping.originalInStorePickup = true;
                    checkout.shipping.shippingETD = etd;
                }
                groupRatesSorted.push( elem );
            });
        
            groupRatesSorted.sort(function( a, b ) {
                if (!(a.inStorePickup||0) && (b.inStorePickup||0))
                    return -1;
                return (a.price - b.price);
            });
        } else if (res.rates && Object.keys(res.rates).length > 0) {
            courierRates = JSON.parse( JSON.stringify( res.couriers ) );
            courierRates.forEach( function( cour, idx, arr ) {
                cour['services'] = [];
                cour['hasServices'] = false;
                cour['active'] = false;
                var svcs = Object.keys( res.services ).map(function( e ) {
                    return res.services[e];
                });
                svcs.filter( function( svc, idx, a ) {
                    if (svc.shippingCourierCode == cour.shippingCourierCode)  
                        return true;
                    return false;    
                }).sort(function( a, b ) {
                    if (!res.rates[ a.shippingServiceCode ] && !res.rates[ b.shippingServiceCode ])
                        return 0;
                    if (!res.rates[ a.shippingServiceCode] && res.rates[ b.shippingServiceCode ]) 
                        return -1;
                    if (res.rates[ a.shippingServiceCode ] && !res.rates[ b.shippingServiceCode ]) 
                        return 1;
                    return ( res.rates[ a.shippingServiceCode ].cost - res.rates[ b.shippingServiceCode ].cost );
                    // return (a.cost - b.cost );
                }).forEach( function( svc, idx, arr ) {
                    svc['active'] = false;
                    if (res.rates[ svc.shippingServiceCode ]) {
                        if (res.shippingRatesDetails && res.shippingRatesDetails[ svc.shippingServiceCode ]) {
                            res.rates[ svc.shippingServiceCode ].details = res.shippingRatesDetails[ svc.shippingServiceCode ];
                            res.rates[ svc.shippingServiceCode ].detailText = shipping.showRatesDetails( res.rates[ svc.shippingServiceCode ] );
                        }
                        cour['services'].push(svc);
                        cour['hasServices'] = true;
                        svc['rate'] = res.rates[ svc.shippingServiceCode ];
                        if (svc.shippingServiceCode == checkout.shippingServiceCode) {
                            checkout.shipping.setShippingMethod(svc.name);
                            checkout.shipping.shippingETD = false;
                            cour['active'] = true;
                            svc['active'] = true;
							if (svc.shippingServiceCode == 'INSTORE' || svc.shippingServiceCode == 'WILLCALL')
								checkout.shipping.originalInStorePickup = true;
                        }
                    }
                });
                cour['index'] = idx;
            });
        }

        var override = {};
        override.enabled = checkout.session.get('shippingOverride');
        override.amount  = checkout.session.get('shippingOverrideAmt');

        var data = {
            checkout: checkout,
            response: res,
            requestedQuoteType: checkout.shipping.requestedQuoteType,
            groupRates: groupRatesSorted,
            globals: checkout.globals,
            CDNstatic: CDNpath,
            selectedServiceGroup: checkout.shippingServiceGroupRates[checkout.shippingServiceGroupID],
            shippingServiceGroupID: checkout.shippingServiceGroupID,
            courierRates: courierRates,
            selectedShippingServiceCode: checkout.shippingServiceCode,
            override: override,
            isDropShip: false
        };

        if (!section || section == 'shipping') {
            if (checkout.cart.items) {
                for (var x in checkout.cart.items) {
                    if (checkout.cart.items[x].data.hasDirectShipStockStatus === '1') {
                        data.isDropShip = true;
                    }
                }
            }

            var html = Jemplate.process( 'checkout_shipping_options', data );
            if (checkout.shipping.$wrap.length) {
                checkout.shipping.$wrap.removeClass('loading');
                checkout.shipping.$wrap.html( html );
                shipping.$shippingChoice = $('input:checked', checkout.shipping.$wrap);
                shipping.inStorePickup = shipping.$shippingChoice.data('instorepickup');
            }
        }

        if (!section || section == 'review') {
            data.review = 1;
            var review_html = Jemplate.process( 'checkout_shipping_options', data );
            $('.change-shipping-modal').html( review_html );
        }        
    };

    shipping.stepTo = function() {

        if (checkout.currentStepName() == 'cart')
            checkout.session.set({
                'step': 'shipping'
            });

        if (
            (
                checkout.currentStepName() != 'shipping'
                && checkout.session.isLoggedIn()
            )
            || checkout.session.get('PayPalConfirmed')
        )
            shipping.proceed();
        else {

            checkout.session.set({
                'step': 'shipping'
            });

            shipping.$proceed.show();


            $('html,body').animate(
                { 'scrollTop': shipping.$anchor.offset().top },
                500
            );

        }
    };

    shipping.proceed = function() {
        shipping.$proceed.hide();
        shipping.$cShopping.hide();
        checkout.login = new Checkout.Login(checkout);
    };

    shipping.loading = function( loadingMsg ) {
        var html = Jemplate.process( 'checkout_shipping_options', {checkout: checkout, loadingMsg: loadingMsg, CDNstatic: CDNpath} );
        if (checkout.shipping.$wrap.length) {
            checkout.shipping.$wrap.addClass('loading');
            checkout.shipping.$wrap.html( html );
        }
    };

    shipping.buildServiceGroupOptions = function() {
        var selectedServiceGroup = checkout.shippingServiceGroupRates[checkout.shippingServiceGroupID]
            , groupRatesSorted = []
            , groupRatesElements = []
            , groupRatesElementsAlt = []

        for (var shippingServiceGroupID in checkout.shippingServiceGroupRates) {
            groupRatesSorted.push(checkout.shippingServiceGroupRates[shippingServiceGroupID]);
        }

        groupRatesSorted.sort(function( a, b ) {
            return (a.price - b.price);
        });

        $.each(groupRatesSorted, function( i, groupRate ) {
            var $service =
                shipping.$serviceTpl
                    .clone(true)
                    .attr('id', 'shipping-service-group-' + groupRate.shippingServiceGroupID);

            $service.find('.shipping-service-name').html(groupRate.cartName);
            if (Object.keys(groupRate.deliveryETA).length) {
                var deliveryETA = isoDateFormatter(groupRate.deliveryETA['1'],true);
                if (groupRate.deliveryETA['2']) {
                    deliveryETA += ' - ' + isoDateFormatter(groupRate.deliveryETA['2'],true);
                }
                $service.find('.shipping-service-daysTransit').html(deliveryETA);
                $('.shipping-daysTransit-header').html('ESTIMATED DELIVERY DATE');
            } else {
                $service.find('.shipping-service-daysTransit').html(groupRate.daysInTransit);
            }

            var rawCostHTML = '';
            if ('rawCost' in groupRate) {

                var colorAlert = '';
                if (parseFloat(groupRate.rawCost) > parseFloat(groupRate.price)) {
                    colorAlert = 'style="color:red"';
                }

                rawCostHTML = '<em class="ecsCost" title="ECS Cost" ' + colorAlert + '>($' + commaSeparate(groupRate.rawCost) + ')</em> ';

            }

            var shipServicePriceHTML = rawCostHTML;
            if (groupRate.originalShippingRetail > 0 && parseFloat(groupRate.originalShippingRetail) > parseFloat(groupRate.price)) {
                $service.find('label.radio').addClass('special-offer');
                shipServicePriceHTML += '<span class="saleTxt">' + groupRate.costMessage + '</span>';
                shipServicePriceHTML += '<span class="pricecut">$' + commaSeparate(groupRate.originalShippingRetail) + '</span>';
                shipServicePriceHTML += '<span class="discountedCost">$' + commaSeparate(groupRate.price) + '</span>';
            } else if (groupRate.price > 0) {
                shipServicePriceHTML += '$' + commaSeparate(groupRate.price);
            } else {
                shipServicePriceHTML += '<div style="color:#1faf52;display:inline-block">FREE</div>';
            }

            $service.find('.shipping-service-price').html(shipServicePriceHTML);

            if (selectedServiceGroup.shippingServiceGroupID == groupRate.shippingServiceGroupID)
                $service.find('input[type=radio]').prop('checked', true);

            if (groupRate.internalOnly) {
                groupRatesElementsAlt.push($service)
            } else {
                groupRatesElements.push($service);
            }

        });

        shipping.$servicesContent.html(groupRatesElements);
        shipping.$servicesContentAlt.html(groupRatesElementsAlt);

        if (groupRatesElementsAlt.length) {
            shipping.$servicesContentAltWrap.show();
        } else {
            shipping.$servicesContentAltWrap.hide();
        }

        shipping.showRatesDetails( selectedServiceGroup );

        // listen for explicit service change
        shipping.$servicesContentAll
            .find('input[type=radio]')
            .on('change', function() {
                var shippingServiceGroupID =
                    $(this)
                        .parents('.shipping-service')
                        .first()
                        .attr('id')
                        .replace('shipping-service-group-', '');

                checkout.session.set({
                    'shippingServiceGroupSet': 1,
                    'shippingServiceSet': 0
                });

                shipping.changeServiceGroup(shippingServiceGroupID);
            });

        shipping.$serviceGroupsWrap.show();
    };

    shipping.changeServiceGroup = function( shippingServiceGroupID, shippingMethod, shippingETD ) {
        var groupRate = checkout.shippingServiceGroupRates[shippingServiceGroupID];

        checkout.session.set({
            'shippingServiceGroupID': shippingServiceGroupID,
			'shippingServiceCode': undefined,
        });

        if ( checkout.user && !checkout.session.get('shippingOverride')) {
            shipping.$overrideAmt.val((parseFloat(groupRate.price) || 0).toMoney());
        }

        checkout.shippingServiceGroupID = shippingServiceGroupID;
        checkout.shipping.setShippingMethod(shippingMethod);
        checkout.shipping.shippingETD = shippingETD;
		checkout.shippingServiceCode = undefined;

        checkout.cart.shipping.total = (parseFloat(groupRate.price) || 0);
        checkout.cart.shipping.originalShippingRetail = (parseFloat(groupRate.originalShippingRetail) || 0);

        checkout.cart.totals.update('shipping');
		// if we are switching to/from in store/will call from not in store/will call
		// silently update the cart

		var	shipinfo_update = function() {
			checkout.shipping.originalInStorePickup = !!checkout.shipping.inStorePickup;
        
        	shipping.showRatesDetails( groupRate );

        	if (checkout.shipinfo) checkout.shipinfo.displayShippingAddress(null, checkout.shipping.inStorePickup);
			checkout.shippingServiceCode = undefined;
		};
		if (!!(checkout.shipping.originalInStorePickup ^ checkout.shipping.inStorePickup)) {
			checkout.setAfterShipping();
			checkout.cart.checkItems(1,0,0,checkout.shipping.inStorePickup).then( shipinfo_update );
		} else {
			shipinfo_update();
		}



    };
    
    shipping.buildServiceOptions = function() {
        var selectedService = checkout.shippingServices[checkout.shippingServiceCode],
            courierRates = {},
            couriersHideOthersWhenAvail = {},
            courierTabs = [],
            couriersContent = [],
            invalidCourierRates = {};

        for (var shippingServiceCode in checkout.shippingRates) {
            var rate = checkout.shippingRates[shippingServiceCode];

            if (!courierRates[rate.shippingCourierCode]) {
                courierRates[rate.shippingCourierCode] = {};
            }

            courierRates[rate.shippingCourierCode][shippingServiceCode] = rate;
        }

        // build the data structure for invalid shipping Rates 
        if (checkout.invalidShippingRates) { 
            for (var shippingServiceCode in checkout.invalidShippingRates) { 
                var invalidRate = checkout.invalidShippingRates[shippingServiceCode]; 

                if (!invalidCourierRates[invalidRate.shippingCourierCode]) {
                    invalidCourierRates[invalidRate.shippingCourierCode] = {}; 
                }

                invalidCourierRates[invalidRate.shippingCourierCode][shippingServiceCode] = invalidRate; 
            } 
        }
        
        $.each(checkout.shippingCouriers, function( i, courier ) {
            if (
                courier.hideOthersWhenAvailable
                && (courier.shippingCourierCode in courierRates)
            ) {
                couriersHideOthersWhenAvail[courier.shippingCourierCode] = 1;
            }
        });

        shipping.couriers = {};

        $.each(checkout.shippingCouriers, function( i, courier ) {
            var hasRates = (courier.shippingCourierCode in courierRates);

            if (!hasRates) {
                if (courier.hideWhenUnavailable) {
                    return;
                } else if (
                    Object.keys(couriersHideOthersWhenAvail).length
                    && !couriersHideOthersWhenAvail[courier.shippingCourierCode]
                ) {
                    return;
                }
            }

            var anchor = '<a data-toggle="tab" data-courier="' + courier.shippingCourierCode + '" href="#shipping-courier-' + courier.shippingCourierCode + '">',
                arrow = '<i class="icon-chevron-right-red"></i>';

            shipping.couriers[courier.shippingCourierCode] = courier;

            if (!hasRates) {
                anchor = '<a href="javascript:void(0)">';
                arrow = '';
            }

            var $tab = $(
                '<li id="shipping-courier-tab-' + courier.shippingCourierCode + '" class="popover-link">'
                    + anchor + '<span class="name">' + courier.name + '</span>' + arrow + '</a></li>'
            );

            if (!hasRates) {
                $tab.addClass('hasPopover')
                    .popover({
                        html: true,
                        trigger: 'click',
                        placement: 'right',
                        content: function() {
                            var msg = courier.name + ' carrier has no shipping services available for this order.'
                                + '<br /><a class="popClose">&times;</a>';

                            if (courier.shippingCourierCode == 'FREIGHT') {
                                msg += '<br /><br />To receive a freight quote for this order, please contact the sales team'
                                    + '<br /> - <span class="pnumber">' + checkout.config.contactInfo.phone + '</span>' + checkout.config.contactInfo.phoneExtra
                                    + '<br /> - <a href="mailto:' + checkout.config.contactInfo.email + '" class="mail">' + checkout.config.contactInfo.email + '</a>'
                                    + '<br /> - <a href="' + checkout.config.contactInfo.liveChatHref + '" class="lchat">Live Chat</a>'
                                    + '<br /> <a class="popClose">X</a>';
                            }
                            return msg;
                        }
                    })
                    .data(checkout.config.bsPopoverData).tip()
                    .find('.popover-title')
                    .hide();
            }
            courierTabs.push($tab);
        });

        shipping.$couriers.html(courierTabs);

        var $courierTabs = shipping.$couriers.find('a[data-toggle="tab"]');

        $courierTabs.on('show.bs.tab', function( e ) {
            var $tab = $(this),
                shippingCourierCode = $(e.target || e.srcElement).data('courier');

            $courierTabs.find('i')
                .removeClass('icon-chevron-right-red')
                .addClass('icon-chevron-right');

            $tab.find('i')
                .removeClass('icon-chevron-right')
                .addClass('icon-chevron-right-red');
        });

        // listen for courier change
        $courierTabs.on('shown.bs.tab', function( e ) {
            checkout.session.set({
                'shippingServiceSet': 1,
                'shippingServiceGroupSet': 0
            });
            shipping.changeCourier(
                $(e.target || e.srcElement).data('courier')
            );

            $('.shipping-service input[type="radio"]').each(function() {
                var $this = $(this);
                if ($this.prop('checked') === true) {
                    $this.closest('li').css({'background' : '#c8c8c8'}).siblings('li').css({'background' : '#fff'});
                }
            });

            $('.srate .sboxError').html(''); 
            $('.srate .theMessage').html('');
            
            var shippingCourierCode = $(e.target).data('courier');
            var $courierContent = $('#shipping-courier-' + shippingCourierCode);
    
            var invalidRates = [];
            
            for (var shippingServiceCode in invalidCourierRates[shippingCourierCode])
                invalidRates.push(invalidCourierRates[shippingCourierCode][shippingServiceCode]);
            
            if (invalidRates.length > 0) {
                var invalidRatesText = '';
            
                $.each(invalidRates, function( i, invalidRate ) {
                    
                    var service = checkout.shippingServices[invalidRate.shippingServiceCode];
                    
                    invalidRatesText += '* ' + service.name;
                    
                    if (invalidRate.cost) {
                        invalidRatesText += '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;($' + invalidRate.rawCost + ') $' + invalidRate.cost;    
                    }

                    if (invalidRate.error) {
                        invalidRatesText += ': <i>' + invalidRate.error + '</i><br>';
                    }

                    if (invalidRate.details) {
                        if (invalidRate.details.dropship.boxes.length > 0)
                            invalidRatesText += '<b>Dropship:</b>';

                        $.each(invalidRate.details.dropship.boxes, function( i, dsBox ) {
                            var products = '';
                            $.each(dsBox.products, function( productID, qty ) {
                                products += '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +'ES#'+ productID + ' -- ' + qty + 'qty <br />';
                            });
                            invalidRatesText +=
                                '&nbsp;&nbsp;Box '+ dsBox.length + ' x ' + dsBox.width + ' x ' + dsBox.height + ' (' + dsBox.weight + ' lbs.):<br/>'+ products;
                        });
                        invalidRatesText += '<br />';

                        if (invalidRate.details.warehouse.boxes.length > 0) {
                            invalidRatesText += '<b>Warehouse:</b>';
                        }

                        $.each(invalidRate.details.warehouse.boxes, function( i, wBox ) {
                            var products = '';
                                $.each(wBox.products, function( productID, qty ) {
                                    products += '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +'ES#'+ productID + ' -- ' + qty + 'qty <br />';
                            });
                            invalidRatesText +=
                                '&nbsp;&nbsp;Box '+ wBox.length + ' x ' + wBox.width + ' x ' + wBox.height + ' (' + wBox.weight + ' lbs.):<br/>'+ products;
                        });
                        invalidRatesText += '<br />';
                    }
                });

                // show any invalid rates
                $('.srate .sboxError').html('<br /><b>Invalid Rates:</b>' + invalidRatesText + '<br />');
            }

        });

        for (var shippingCourierCode in courierRates) {
            var $courierContent = shipping.$courierServicesTpl.clone(true).attr('id', 'shipping-courier-' + shippingCourierCode),
                services = [],
                rates = [];

            for (var shippingServiceCode in courierRates[shippingCourierCode]) {
                rates.push(courierRates[shippingCourierCode][shippingServiceCode]);
            }

            rates.sort(function( a, b ) {
                return (a.cost - b.cost);
            });

            $.each(rates, function( i, rate ) {
                var service = checkout.shippingServices[rate.shippingServiceCode],
                    $service = shipping.$serviceTpl.clone(true).attr('id', 'shipping-service-'+rate.shippingServiceCode);

                $service.find('.shipping-service-name').html(service.name);

                var rawCostText = '';
                if (rate.rawCost) {
                    rawCostText = '($'+rate.rawCost +')';
                }

                var colorAlert = '';

                if (parseInt(rate.rawCost) > parseInt(rate.cost)) {
                    colorAlert = 'style="color:red"';
                }

                var serviceCostHTML = '<em class="ecsCost" title="ECS Cost" ' + colorAlert + '>' + rawCostText + '</em> ' + '$' + rate.cost;
                if (rate.originalShippingRetail > 0 && rate.originalShippingRetail > rate.cost) {
                    serviceCostHTML = '<em class="ecsCost" title="ECS Cost" ' + colorAlert + '>' + rawCostText + '</em> ';
                    serviceCostHTML += '<span class="pricecut">$' + rate.originalShippingRetail + '</span>';
                    serviceCostHTML += '<span class="discountedCost">$' + rate.cost + '</span>';
                }
                $service.find('.shipping-service-price').html(serviceCostHTML);
                
                if (selectedService.shippingServiceCode == rate.shippingServiceCode)
                    $service.find('input[type=radio]').prop('checked', true);

                services.push($service);
            });

            $courierContent.find('ul').html(services);

            couriersContent.push($courierContent);
        }

        shipping.$couriersContent.html(couriersContent);

        // listen for explicit service change
        shipping.$couriersContent
            .find('input[type=radio]')
            .on('change', function() {
                var $this = $(this);
                $this.closest('li').css({'background' : '#c8c8c8'}).siblings('li').css({'background' : '#fff'});
                var shippingServiceCode = $this.parents('.shipping-service').first().attr('id').replace('shipping-service-', '');

                checkout.session.set({
                    'shippingServiceSet': 1
                });

                shipping.changeService(shippingServiceCode);
            });

        $('#shipping-courier-tab-' + selectedService.shippingCourierCode + ' a').tab('show');

        shipping.showServiceDesc(selectedService.shippingServiceCode);

        shipping.$serviceServicesWrap.show();
    };

    shipping.showServiceDesc = function( shippingServiceCode ) {
        var service = checkout.shippingServices[shippingServiceCode],
            courier = shipping.couriers[service.shippingCourierCode],
            shippingRatesDetails;

        if (checkout.shippingRatesDetails && checkout.shippingRatesDetails[shippingServiceCode])
            shippingRatesDetails = checkout.shippingRatesDetails[shippingServiceCode];
        
        shipping.$serviceDesc.find('.title').html(courier.name + ' - ' + service.name);
        shipping.$serviceDesc.find('.body').html(service.description);
        
        var $courierContent = $('#shipping-courier-' + service.shippingCourierCode),
            boxInfoDropShip = '',
            boxInfoWarehouse = '';
        
        // add drop ship info if available
        if (shippingRatesDetails && shippingRatesDetails.dropship.boxes.length > 0) {
            
            boxInfoDropShip = '<b>Direct Ship:</b>' + '<i>(' + shippingRatesDetails.dropship.source  + ')</i><br /><br />';
            
            $.each(shippingRatesDetails.dropship.boxes, function( i, dsBox ) {
                var products = '';
                $.each(dsBox.products, function( productID, qty ) {
                    products += '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + 'ES#' + productID + ' -- ' + qty + 'qty <br />';
                });

                boxInfoDropShip +=
                    'Box ' + dsBox.length + ' x ' + dsBox.width + ' x ' + dsBox.height + ' (' + dsBox.weight + ' lbs.):<br/>' + products;

            });
        }
        
        // add warehouse info if available
        if (shippingRatesDetails && shippingRatesDetails.warehouse.boxes.length > 0) {
            
            boxInfoWarehouse = '<b>Warehouse:</b>' + '<i>(' + shippingRatesDetails.warehouse.source  + ')</i><br /><br />';
            
            $.each(shippingRatesDetails.warehouse.boxes, function( i, wBox ) {
                var products = '';
                $.each(wBox.products, function( productID, qty ) {
                    products += '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +'ES#'+ productID + ' -- ' + qty + 'qty <br />';
                });

                boxInfoWarehouse +=
                    'Box ' + wBox.length + ' x ' + wBox.width + ' x ' + wBox.height + ' (' + wBox.weight + ' lbs.):<br/>' + products;

            });
        }
        
        // show all the details, for debugging purposes only
        //$courierContent.find('.sboxInfo').html( JSON.stringify(shippingRatesDetails, null, 2) );    
        
        $courierContent.find('.sboxInfo').html(boxInfoDropShip + '<br />' + boxInfoWarehouse);

        shipping.$serviceDesc.show();
    };

    shipping.changeCourier = function( shippingCourierCode ) {
        var selectedService = checkout.shippingServices[checkout.shippingServiceCode];

        if (selectedService.shippingCourierCode == shippingCourierCode) return;

        shipping.$serviceDesc.hide();

        var $service = $('#shipping-courier-'+shippingCourierCode).find('.shipping-service').first();

        $service.find('input[type=radio]').prop('checked', true);

        shipping.changeService(
            $service.attr('id').replace('shipping-service-', '')
        );
    };

    shipping.changeService = function( shippingServiceCode, shippingMethod ) {
        var rate = checkout.shippingRates[shippingServiceCode];

        checkout.session.set({
            'shippingServiceCode': shippingServiceCode,
			'shippingServiceGroupID': undefined
        });

        if (
            checkout.user
            && !checkout.session.get('shippingOverride') 
            && shipping.$overrideAmt
        )
            shipping.$overrideAmt.val((parseFloat(rate.cost) || 0).toMoney());

        checkout.shippingServiceCode = shippingServiceCode;
        checkout.shipping.setShippingMethod(shippingMethod);
        checkout.shippingServiceGroupID = undefined;
		var inStorePickup = false;
		var internationalShipping = false;

		var update_shipping = function() {
			checkout.shipping.originalInStorePickup = inStorePickup;
			checkout.shipping.originalInternationalShipping = internationalShipping;
		
			checkout.cart.shipping.total = (parseFloat(rate.cost) || 0);
			checkout.cart.shipping.originalShippingRetail = (parseFloat(rate.originalShippingRetail) || 0);
			// if (checkout.shipinfo) checkout.shipinfo.displayShippingAddress();
			if (checkout.shipinfo) checkout.shipinfo.displayShippingAddress(null, inStorePickup);
			checkout.cart.totals.update('shipping');

		};
		// if changing from instore to non instore, switch ETAs for cart
		if (checkout.config.instoreShippingServices[ shippingServiceCode ] == 1)
			inStorePickup = true;
		
		if (checkout.session.get('shipping.country') != 'US') 
			internationalShipping = true;
		
		if ( checkout.shipping.originalInternationalShipping ^ internationalShipping )
			checkout.cart.checkItems(1,0,0, internationalShipping ).then( update_shipping );
		else if (!!(checkout.shipping.originalInStorePickup ^ inStorePickup)) 
			checkout.cart.checkItems(1,0,0,inStorePickup).then( update_shipping );
		else 
			update_shipping();
	
    };

    shipping.showDisclaimers = function() {
        shipping.$disclaimers.html(
            ((checkout.shippingMultiLocations) ?
                '<span class="multi-loc">Your order will ship from multiple locations.</span>'
                : ''
            )
            + ((checkout.config.siteAbbr != 'ECS') ? '<span class="nopickup">' + checkout.config.siteName + ' does not offer in-store pickup</span>' : '')
        );
    };

    shipping.buildOverride = function() {
        if (checkout.user) {
            var overrideAmt = checkout.session.get('shippingOverrideAmt');

            if (checkout.session.get('shippingOverride')) {
                $('.js-shipping-override').prop('checked', true);
                $('.js-shipping-override-amount').val((parseFloat(overrideAmt) || 0).toMoney());
            } else {
                $('.js-shipping-override-amount').val(checkout.cart.totals.values.shipping);
            }

            shipping.$overrideWrap.show();
        }
    };

    shipping.changeDisplayType = function() {
        var selectedDisplayType = $(this).val();
        checkout.shipping.requestedQuoteType = selectedDisplayType;

        checkout.session.set({
            'shippingDisplayType': selectedDisplayType,
        });

        checkout.cart.totals.calc(true);
    }

    shipping.changeOverride = function() {
        var override = ($('.js-shipping-override').prop('checked') ? 1 : 0),
            overrideAmt = (parseFloat($('.js-shipping-override-amount').val()) || 0);

        $('.js-shipping-override-amount').prop( 'disabled', !override );

        checkout.session.set({
            'shippingOverride': override,
            'shippingOverrideAmt': overrideAmt
        });

        checkout.cart.totals.update('shipping');
    };

    shipping.showRatesDetails = function( groupRate ) {
        var details = groupRate.details;
        if (! details) {
            // shipping.$groupDetailsContainer.hide();
            return;
        }

        var descriptions = [];

        var dropship = details.dropship;
        if (dropship
            && dropship.boxes
            && dropship.boxes.length > 0
            ) {
            descriptions.push(
                shipping.getShipmentDescription( dropship, 'Direct Ship' )
            );
        }

        var warehouse = details.warehouse;
        if (warehouse
            && warehouse.boxes
            && warehouse.boxes.length > 0
            ) {
            descriptions.push(
                shipping.getShipmentDescription( warehouse, 'Warehouse' )
            );
        }
        return descriptions;

        // var descriptionHTML = descriptions.join("<br /><br />");
        // shipping.$groupDetailsContainer.html( descriptionHTML ).show();
    };

    shipping.getShipmentDescription = function( shipment, name ) {
        var description = [];

        description.push(
            '<b>' + name + ':</b>' +
            '<i>(' + shipment.source + ')</i>'
        );
        $.each(shipment.boxes, function( i, box ) {
            description.push(
                'Box ' + box.length +
                ' x ' + box.width +
                ' x ' + box.height +
                ' (' + box.weight + ' lbs.):'
            );
            $.each(box.products, function( productID, qty ) {
                description.push(
                    '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                    'ES#' + productID +
                    ' -- ' +
                    qty + ' qty'
                );
            });
        });

        return description.join("<br />");
    };

    shipping.error = function( errorText ) {
        if (errorText)  {
            $('.shipping-address-error strong').html( errorText );
            $('.shipping-address-error').show();
        } else {
            $('.shipping-address-error').hide();
        }
    };
    
    shipping.setShippingMethod = function( method ) {
        if (checkout.shipping.shippingMethod != method && checkout.currentStepName() == 'review') {
            $('.js-shipping-info-alert-info').find('.msg-text').html('Your shipping options have changed. Click "Change Shipping Method" below to see your new options.');
            $('.js-shipping-info-alert-info').css('display', 'block');
            $('.js-shipping-method').html(method); // update review shipping method
        }
        checkout.shipping.shippingMethod = method;
    };

    shipping.init();
};
